import {stepIconClasses, stepLabelClasses, stepButtonClasses, ThemeOptions, Breakpoints} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiStepper = ({stepper}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiStepper: {
    styleOverrides: {
      root: {
        justifyContent: 'flex-start',
        marginBottom: 16,

        [mediaQueries.down('md')]: {
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }
      }
    }
  },

  MuiStep: {
    styleOverrides: {
      root: {
        [`.${stepButtonClasses.root}:hover`]: {
          backgroundColor: stepper.container.desktop.background.color,
          borderRadius: stepper.container.desktop.border.radius.all
        },
        padding: 0
      },

      horizontal: {
        [`.${stepLabelClasses.root}`]: {
          [mediaQueries.down('md')]: {
            alignItems: 'center',
            flexDirection: 'column'
          }
        }
      }
    }
  },

  MuiStepButton: {
    styleOverrides: {
      root: {
        margin: 0,
        padding: stepper.container.desktop.padding.all,
        justifyContent: 'flex-start',
        width: 'auto',
        [mediaQueries.down('md')]: {
          padding: '0px 16px'
        }
      }
    }
  },

  MuiStepIcon: {
    styleOverrides: {
      root: {
        color: stepper.icon.desktop.background.color,
        height: stepper.icon.desktop.height,
        width: stepper.icon.desktop.width,

        [`&.${stepIconClasses.completed}`]: {
          color: stepper.icon.desktop.completed.background.color
        },

        [`&.${stepIconClasses.active}`]: {
          color: stepper.icon.desktop.current.background.color,

          [`.${stepIconClasses.text}`]: {
            fill: stepper.icon.desktop.current.font.color
          }
        }
      },

      text: {
        fill: stepper.icon.desktop.font.color,
        fontSize: stepper.icon.desktop.font.size,
        fontWeight: stepper.icon.desktop.font.weight,
        lineHeight: stepper.icon.desktop.font.lineHeight
      }
    }
  },

  MuiStepLabel: {
    styleOverrides: {
      root: {},

      label: {
        color: stepper.label.desktop.font.color,
        fontWeight: stepper.label.desktop.font.weight,
        margin: `0 0 0 4px`,

        [`&.${stepLabelClasses.active}`]: {
          color: stepper.label.desktop.current.font.color,
          fontSize: stepper.label.desktop.current.font.size,
          fontWeight: stepper.label.desktop.current.font.weight,
          lineHeight: stepper.label.desktop.current.font.lineHeight
        },
        [`&.${stepLabelClasses.alternativeLabel}`]: {
          margin: `4px 0 0 0`
        },
        [mediaQueries.down('md')]: {
          margin: `4px 0 0 0`,
          textAlign: 'center'
        }
      },
      iconContainer: {
        paddingRight: 0,
        borderColor: stepper.icon.desktop.border.color,
        borderStyle: stepper.icon.desktop.border.style,
        borderWidth: stepper.icon.desktop.border.width,
        borderRadius: stepper.icon.desktop.border.radius.all,
        [`&.${stepLabelClasses.active}`]: {
          backgroundColor: stepper.icon.desktop.current.background.color,
          borderColor: stepper.icon.desktop.current.background.color
        },
        [`&.${stepLabelClasses.completed}`]: {
          borderColor: stepper.icon.desktop.completed.background.color,
          background: 'radial-gradient(circle, rgba(0,38,119,0) 60%, rgba(0,38,119,1) 65%)'
        }
      }
    }
  },

  MuiStepConnector: {
    styleOverrides: {
      root: {
        marginRight: 4,
        flexBasis: stepper.seperator.desktop.width,
        maxWidth: stepper.seperator.desktop.width,
        [mediaQueries.down('md')]: {
          display: 'none'
        }
      },

      line: {
        borderTopColor: stepper.seperator.desktop.background.color,
        borderTopWidth: stepper.seperator.desktop.height,
        borderTopStyle: 'solid'
      }
    }
  }
});
